export interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
  redirectUrl?: string;
}

function envFirst(...keys: string[]): string {
  for (const k of keys) {
    const v = String((process.env as Record<string, string | undefined>)[k] ?? "").trim();
    if (v) return v;
  }
  return "";
}

export function hasKeycloakConfig(): boolean {
  const url = envFirst("VUE_APP_KEYCLOAK_URL", "VUE_APP_KEYCLOAK_BASE_URL");
  const realm = envFirst("VUE_APP_KEYCLOAK_REALM");
  const clientId = envFirst("VUE_APP_KEYCLOAK_CLIENT_ID");
  return Boolean(url && realm && clientId);
}

export function hasKeycloakRedirectConfig(): boolean {
  const redirect = envFirst("VUE_APP_KEYCLOAK_REDIRECT_URL", "VUE_APP_KEYCLOAK_REDIRECT_URI");
  return Boolean(redirect);
}

export function hasKeycloakConfigStrict(): boolean {
  return Boolean(
    process.env.VUE_APP_KEYCLOAK_URL &&
      process.env.VUE_APP_KEYCLOAK_REALM &&
      process.env.VUE_APP_KEYCLOAK_CLIENT_ID
  );
}

function normalizeUrl(value: string): string {
  if (!value) return value;
  if (value.startsWith("http://") || value.startsWith("https://")) {
    return value;
  }
  return `http://${value}`;
}

export function getKeycloakConfig(): KeycloakConfig {
  const url = normalizeUrl(envFirst("VUE_APP_KEYCLOAK_URL", "VUE_APP_KEYCLOAK_BASE_URL"));
  const realm = envFirst("VUE_APP_KEYCLOAK_REALM");
  const clientId = envFirst("VUE_APP_KEYCLOAK_CLIENT_ID");
  const redirectRaw = envFirst("VUE_APP_KEYCLOAK_REDIRECT_URL", "VUE_APP_KEYCLOAK_REDIRECT_URI");
  const redirectUrl = redirectRaw ? normalizeUrl(redirectRaw) : undefined;

  if (!url || !realm || !clientId) {
    throw new Error(
      "Missing Keycloak env: VUE_APP_KEYCLOAK_URL|VUE_APP_KEYCLOAK_BASE_URL, VUE_APP_KEYCLOAK_REALM, VUE_APP_KEYCLOAK_CLIENT_ID"
    );
  }

  return { url, realm, clientId, redirectUrl };
}

